module.exports = __webpack_public_path__ + "static/media/surrealist_lightbulb.60f73334.gif";